module.exports = __webpack_public_path__ + "img/_menu_vert.0f28775f.svg";